/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_XxlInputs */

const en_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXL`)
};

const es_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXL`)
};

const fr_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXL`)
};

const de_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXL`)
};

const ja_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXL`)
};

const zh_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXL`)
};

const ar_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كبير جداً جداً (XXL)`)
};

const id_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXL`)
};

const it_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXL`)
};

const ru_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXL`)
};

const pt_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XG (XXL)`)
};

const ko_val_xxl = /** @type {(inputs: Val_XxlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXL`)
};

/**
* | output |
* | --- |
* | "XXL" |
*
* @param {Val_XxlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_xxl = /** @type {((inputs?: Val_XxlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_XxlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_xxl(inputs)
	if (locale === "es") return es_val_xxl(inputs)
	if (locale === "fr") return fr_val_xxl(inputs)
	if (locale === "de") return de_val_xxl(inputs)
	if (locale === "ja") return ja_val_xxl(inputs)
	if (locale === "zh") return zh_val_xxl(inputs)
	if (locale === "ar") return ar_val_xxl(inputs)
	if (locale === "id") return id_val_xxl(inputs)
	if (locale === "it") return it_val_xxl(inputs)
	if (locale === "ru") return ru_val_xxl(inputs)
	if (locale === "pt") return pt_val_xxl(inputs)
	return ko_val_xxl(inputs)
});